
export const COLOR_SEQUENTIAL_TEAL = {
    '3': ['#69C3DB', '#198BA5', '#005B6E'],
    '4': ['#77CDE4', '#3AA1BC', '#04768E', '#005265'],
    '5': ['#83D4EA', '#51B2CB', '#198BA5', '#00697E', '#004C5D'],
    '6': ['#97DDF0', '#66C1D9', '#339DB7', '#077A92', '#005C70', '#004353'],
    '7': ['#9EE0F2', '#71C9E1', '#47ABC5', '#198BA5', '#016E85', '#005668', '#004050'],
    '8': ['#ADE5F5', '#80D2E8', '#5AB9D2', '#309AB5', '#0A7E97', '#00657A', '#004F61', '#003C4B'],
    '9': ['#BCEAF8', '#8ED9EE', '#69C3DB', '#42A7C1', '#198BA5', '#027188', '#005B6E', '#004757', '#003543'],
    'default': ['#BCEAF8', '#8ED9EE', '#69C3DB', '#42A7C1', '#198BA5', '#027188', '#005B6E', '#004757', '#003543']
};

export const COLOR_MULTI_HUE_INFERNO = {
    '3': ['#000004', '#AC3D50', '#FCFEA3'],
    '4': ['#000004', '#6E1A6C', '#DA701A', '#FCFEA3'],
    '5': ['#000004', '#500F6C', '#AC3D50', '#E89306', '#FCFEA3'],
    '6': ['#000004', '#3E0C66', '#882765', '#CA5830', '#EDA903', '#FCFEA3'],
    '7': ['#000004', '#330B5E', '#6E1A6C', '#AC3D50', '#DA701A', '#EFB808', '#FCFEA3'],
    '8': ['#000004', '#2B0B55', '#5B126D', '#8F2B62', '#BF4C3D', '#E2810E', '#F0C00E', '#FCFEA3'],
    '9': ['#000004', '#260A4F', '#500F6C', '#7E2269', '#AC3D50', '#D16127', '#E89306', '#F2CB1B', '#FCFEA3'],
    '10': ['#000004', '#210A48', '#450D69', '#6D1A6C', '#972F5E', '#BC4A40', '#D96D1C', '#EA9B04', '#F2CD1F', '#FCFEA3'],
    '11': ['#000004', '#1E0943', '#3E0C66', '#62156D', '#882765', '#AC3D50', '#CA5830', '#E17D11', '#EDA903', '#F4D62F', '#FCFEA3'],
    'default': ['#000004', '#1E0943', '#3E0C66', '#62156D', '#882765', '#AC3D50', '#CA5830', '#E17D11', '#EDA903', '#F4D62F', '#FCFEA3']
};

export const COLOR_QUALITATIVE_CATEGORICAL = {
  '10': ['#309AB5', '#CC861E', '#2BA160', '#D13630', '#8256D8', '#744E45', '#E369B9', '#6D7178', '#1D6EDB', '#607A1F'],
  'default': ['#309AB5', '#CC861E', '#2BA160', '#D13630', '#8256D8', '#744E45', '#E369B9', '#6D7178', '#1D6EDB', '#607A1F', '#85D8EE', '#EFC85C', '#68E398', '#FD9484', '#B8A6EC', '#B99279', '#FFB6E2', '#ADB1B8', '#72B5FF', '#9DBB60']
};

export const COLOR_BACKGROUND = '#EEEEEE';

export const COLOR_ADD_DIM = {colorMix: '#FFFFFF', weight: 75};

export const BRUSH_STROKES = ["#696969", "#8884d8"];
